import '../scss/theme.css';
import '../scss/front-naviti.scss';

import './components/back-to-top.js'
import './components/language-switcher.js'
import './components/form-handler.js'
import './components/main-menu.js'

if (import.meta.hot) {
  import.meta.hot.accept();
}

(function($) {
  $(document).on('click', '.rank-math-list-item', function(e) {
    e.preventDefault();

    const isOpen = $(this).hasClass('is-open');

    $(this).toggleClass('is-open', !isOpen);
    $(this).find('.rank-math-answer').stop().slideToggle(200);
  })
})(jQuery);